import { chakra } from '@chakra-ui/react';
import { createDomMotionComponent } from 'framer-motion';

// todo(#671): why is the documented way not working? (https://chakra-ui.com/getting-started/with-framer)

export const MotionBox = chakra(createDomMotionComponent('div'));
export const MotionListItem = chakra(createDomMotionComponent('li'));
